import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AliasService } from 'src/app/card-operations/services/alias.service';

@Component({
  selector: 'app-favorite-card-alias',
  templateUrl: './favorite-card-alias.component.html',
  styleUrls: ['./favorite-card-alias.component.scss', '../../../../home/home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FavoriteCardAliasComponent implements OnInit {
  @Input() alias!:string;

  private subscriptions = new Subscription();

  constructor(
    private aliasService: AliasService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.subscriptions.add(
      this.aliasService.onStrategyChange$.subscribe(() => {
        this.cd.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public getFormattedAliasNumber(alias: string): string{
    return this.aliasService.getFormattedAlias(alias);
  };
  
}
